import React from "react";
import ProfileAndSettings from "views/Config/Profiles/Common";
import ConfigDSCPProfilesHelpModal from "./Help";
import DSCPProfileSettingsHelpModal from "./SettingsHelp";
import { composedAPI } from "./api";
import dscpComposition from "./composition";

const ConfigDSCPProfiles = ({ ...settings }) => (
  <>
    <ProfileAndSettings
      {...dscpComposition}
      {...composedAPI}
      {...settings}
    />
    <ConfigDSCPProfilesHelpModal />
    <DSCPProfileSettingsHelpModal />
  </>
);

export default ConfigDSCPProfiles;
